// extracted by mini-css-extract-plugin
export var news = "news-module--news--FeetM";
export var news__category_list = "news-module--news__category_list--3pH2L";
export var current = "news-module--current--3aFYm";
export var news__category_list__current_anchor = "news-module--news__category_list__current_anchor--32lZE";
export var news__boxwrap = "news-module--news__boxwrap--14muI";
export var news__box = "news-module--news__box--2u-36";
export var news__category = "news-module--news__category--3NMBV";
export var news__smalltext = "news-module--news__smalltext--jrZZz";
export var news__date = "news-module--news__date---tudU";
export var news__newsbtn = "news-module--news__newsbtn--2xqU4";
export var news__pageTitle = "news-module--news__pageTitle--1USty";
export var pageTitle_decoration_1 = "news-module--pageTitle_decoration_1--3WrWC";